import { useEffect } from 'react';
import ReactDOM from "react-dom";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Select from "react-select";

import { actionsConfig } from '../../utils/actionsConfig';
import ButtonCustom from '../CustomButtom/ButtonCustom';
import { getUserReasignacionCaso, saveFilesAction, setFormInfo, setLoadingHD } from '../../slices';
import { yupResolver } from '@hookform/resolvers/yup';
import { validationsSchemaHelpdeskActions } from '../../utils/validationsSchemaHelpdesk';
import { instanceAxiosPrivate } from '../../axios';



export const DynamicModal = ({isOpen, handleClose, size = null, action = null, caseS = {}}) => {

  const actionSelected = actionsConfig.find(item => item.id === action)
  const dispatch = useDispatch() 
  const { prioridades, userreasignacioncaso } = useSelector((state) => state.helpdesk);
  const { perfil } = useSelector((state) => state.user);

  const { 
    control,
    reset,
    register,
    handleSubmit,
    formState: { errors }, 
    setValue
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: yupResolver(validationsSchemaHelpdeskActions(actionSelected, caseS)),
    shouldUnregister: true,
    key: actionSelected?.id,
  });

  const onSubmit = async (data) => { 
    try {
      for (var key in data) {
        if (key.startsWith("evidence")) delete data[key];
      };
        
      const infoForm = {
        id_hd2_case: data.id_hd2_case,
        id_hd2_status:  actionSelected.status || caseS.id_hd2_status,

        user_id: data.user_id,
        user_register: data.user_register,
        user_caso: data.user_caso,
        
        id_organizacion: data.id_organizacion,
        
        description: data.description,
        prioridad: data.prioridad,
        fecha_cierre: data.fecha_cierre,
        
        url: actionSelected.url,
        type: actionSelected.type,

        accion: data.accion
      }    

      await dispatch(setFormInfo(infoForm))
      await dispatch(saveFilesAction())

      hidenModal()
    } catch (error) {
      dispatch(setLoadingHD(false));
      toast.error(error)
    }
  }


  const hidenModal = ()  => {
    handleClose()
    reset()
  }
  
  const getAsignacionAgente = async () => {    
    try {     
      dispatch(setLoadingHD(true));
      await dispatch(getUserReasignacionCaso(caseS.id_hd2_organizacion_niveles))  
      dispatch(setLoadingHD(false));   
    } catch (error) {
      toast.error(error.msg);
      dispatch(setLoadingHD(false));
    }
  }
  //set Values
  const setDataHiddenInputs = (caseS) => {
    setValue('id_hd2_case', caseS.id);
    setValue('user_id', perfil.user_id);
    setValue('user_register', perfil.user_id);
    setValue('id_organizacion', caseS.id_hd2_organizacion_niveles);    
  }

  // save file in window
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    //guardar el archivo
    const instA = new instanceAxiosPrivate();
    if (file) {
        instA.setItemGeneral("evidence", file);
    }
  };


  useEffect(() => {    
    if (action === 'reasignar') {
      getAsignacionAgente()     
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action])
    
  useEffect(() => {
    setDataHiddenInputs(caseS)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseS, actionSelected])
  
  useEffect(() => {
      const closeOnEscapeKey = e => e.key === "Escape" ? handleClose() : null;
      document.body.addEventListener("keydown", closeOnEscapeKey);
      return () => {
          document.body.removeEventListener("keydown", closeOnEscapeKey);
      };
      
  }, [handleClose]);

  useEffect(() => {
    if (actionSelected?.fields) {
      actionSelected.fields.forEach((field) => {
        if (field.type === "hidden" && field.value) {
          setValue(field.name, field.value);
        }
      });
    }
  }, [actionSelected, setValue]);
  

  let  myModalContainer;

  if (!isOpen) return null;

  if (window !== "undefined") {
      myModalContainer = document.querySelector("#modal");    
  }

  return (
    isOpen &&
    ReactDOM.createPortal(
        <div className="modal fade show"  id="modal" style={{paddingRight: '17px', display: 'block', backgroundColor: "rgba(0, 0, 0, 0.7)", backdropFilter: 'blur(5px)'}} aria-modal="true" data-backdrop="static" role='dialog'>
            <div className={`modal-dialog ${ size || 'modal-xl'  }`}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title font-weight-bold">{ actionSelected.label }</h4>
                        
                        <button 
                            type="button" 
                            onClick={handleClose || hidenModal}  
                            className="close" 
                            data-dismiss="modal" 
                            aria-label="Close"
                        >
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form className="col-12" onSubmit={handleSubmit(onSubmit)}>
                          <input type="hidden"  {...register('id_hd2_case')}/>
                          <input type="hidden" {...register('user_id')} />
                          <input type="hidden" {...register('user_register')} />
                          <input type="hidden" {...register('id_organizacion')} />  
                                                  
                          <div className="row">
                            {
                              actionSelected.fields.map((field) => (
                                <div 
                                  className={`
                                    ${ 
                                      (field.type !== "hidden" )
                                        ? ((actionSelected.id === "reasignar" ) 
                                          ? ((caseS.id_hd2_status === 2 || caseS.id_hd2_status === 5) 
                                            ? ( (field.id === "hide" )  
                                              ? "d-none" : "d-flex flex-column" 
                                              ) : "d-flex flex-column" 
                                            ) 
                                          : "d-flex flex-column" 
                                      ) : "d-none"
                                    }  
                                    col-12 col-md-12 px-1
                                  `}
                                  key={field.name} 
                                >
                                  <div className="d-flex flex-row py-0 my-0 mt-2">
                                    <div className="input-group-prepend py-0">
                                      <span className="input-group-text" id={field.label}>
                                        {field.label}
                                      </span>
                                    </div>
                                  <div className="form-control py-0 px-0 m-0 border-0">
                                    {
                                      field.type === "textarea" 
                                      ? (
                                        <Controller
                                          control={control}
                                          render={({ field: { onChange, value, name } }) => {
                                            const selectChange = (selected) => {
                                              onChange(selected.target.value);
                                            };
                                            return (
                                              <textarea
                                                onChange={selectChange}
                                                value={value}
                                                name={name}
                                                className="form-control"
                                                height="38"
                                              />
                                            );
                                          }}
                                          name={field.name}
                                        />
                                      ) 
                                      : field.type === "select" 
                                      ? (
                                        <Controller
                                            control={control}
                                            render={({
                                              field: { onChange, value, name, ref },
                                            }) => {
                                              const options = userreasignacioncaso;

                                              const currentSelection = options.find(
                                                (c) => c.value === value
                                              );
                                              const selectChange = (selected) => {
                                                onChange(selected.value);
                                              };
                                              return (
                                                <Select
                                                  label=""
                                                  instaceid="selectbox"
                                                  ref={ref}
                                                  value={currentSelection}
                                                  name={name}
                                                  options={options}
                                                  theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                  })}
                                                  className="react-select-container border-1"
                                                  onChange={selectChange}
                                                  isClearable 
                                                />
                                              );
                                            }}
                                            name={field.name}
                                          />
                                      )
                                      : field.type === "select2"
                                      ? (
                                        <Controller
                                            control={control}
                                            render={({
                                              field: { onChange, value, name, ref },
                                            }) => {
                                              const options = prioridades;
                                              
                                              const currentSelection = options.find(
                                                (c) => c.value === value
                                              );
                                              const selectChange = (selected) => {
                                                onChange(selected.value);
                                              };
                                              return (
                                                <Select
                                                  label=""
                                                  instaceid="selectbox"
                                                  ref={ref}
                                                  value={currentSelection}
                                                  name={name}
                                                  options={options}
                                                  theme={(theme) => ({
                                                    ...theme,
                                                    borderRadius: 0,
                                                  })}
                                                  className="react-select-container border-1"
                                                  onChange={selectChange}
                                                  isClearable 
                                                />
                                              );
                                            }}
                                            name={field.name}
                                          />
                                      )  : field.type === "file" 
                                      ?(
                                        <Controller
                                          control={control}
                                          render={({ field: { onChange, ref } }) => (
                                            <>
                                              <input
                                                type={field.type}
                                                id={field.name}
                                                className="form-control"
                                                onChange={(event) => {
                                                  onChange(event.target.files[0]);
                                                  handleFileChange(event);
                                                }}
                                                ref={ref}
                                              />                              
                                            </>
                                          )}
                                          name={field.name}
                                        />
                                      )
                                      : (
                                        <input
                                          type={field.type}
                                          id={field.name}
                                          defaultValue={field.value || ""}
                                          {...register(field.name)}
                                          className={`form-control ${field.type === "hidden" ? "d-none" : ""}`}
                                        />
                                      )
                                    }                                    
                                  </div>
                                  </div>
                                  {errors[field.name] && (
                                    <p className="py-0 my-0">
                                      {
                                        errors[field.name].type === "required" 
                                        ? "Este campo es requerido" 
                                        : errors[field.name].message
                                      }
                                    </p>
                                  )}
                                </div>
                              ))
                            }

                          </div>
                        

                        <div className="row px-1 mt-2">
                          <div className="col-12 px-0">
                            <ButtonCustom
                              type="button"
                              classnames="btn btn-danger py-2 px-4 text-white fw-bold m-1 text-uppercase"
                              onClick={handleSubmit(onSubmit)} 
                            >
                              { actionSelected.id !== 'cotizar' ? (actionSelected.id + " caso") : actionSelected.id} &nbsp;
                            </ButtonCustom>
                          </div>
                        </div>
                        </form>
                    </div>                
                </div>
            </div>
        </div>,
        myModalContainer
    )
  );
}

//<textarea { ...register(field.name, {required: true}) }></textarea>